import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';
import Topbar from './Topbar';

import EventsPanel from './EventsPanel';
import ReportsPanel from './ReportsPanel';
import GeocercasPanel from './GeocercasPanel';
import MisLugaresPanel from './MisLugaresPanel';
import VehicleImageCarousel
  from './VehicleImageCarousel/VehicleImageCarousel';

  function getVehicleKey(vehicle) {
  return String(
    vehicle?.imei ||
    vehicle?.uniqueId ||
    vehicle?.id ||
    vehicle?.name ||
    ''
  );
}

function MonitoringLayout({
  monitorAccounts = [],
  sessionUserId,
  selectedMonitorUserId,
  onChangeMonitoring,
  alertas = [],
  eventos = [],
  monitorUserId,
  vehicles = [],
 
 
  usuarios = [],

  geocercas = [],
  setGeocercas,
  modoCrearGeocerca,
  setModoCrearGeocerca,
  geocercaTemporal,
  setGeocercaTemporal,
  geocercaSeleccionada,
  setGeocercaSeleccionada,

  vistaGeocercas,
setVistaGeocercas,
folderTabActiva,
setFolderTabActiva,
  vehiculoSeleccionado,
  setVehiculoSeleccionado,

  activoExpandido,
setActivoExpandido,
  moduloActivo,
  setModuloActivo
}) {
  const [isMobile, setIsMobile] = useState(isMobileLayout);
 
 

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileLayout());
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    if (folderTabActiva === 'informes') {
      setModuloActivo('informes');
      setFolderTabActiva(null);
      setActivoExpandido(false);
    }
  }, [folderTabActiva, setModuloActivo, setFolderTabActiva, setActivoExpandido]);

  const panelActivosAbierto = moduloActivo === 'vehiculos';

  const panelFolderActivo =
    moduloActivo === 'administracion' || moduloActivo === 'informes' || (isMobile && moduloActivo === 'eventos')
      ? null
      : folderTabActiva;

const gpsOnline = vehicles.filter(
  (v) => v.connectionStatus === 'ONLINE'
);

const gpsOffline = vehicles.filter(
  (v) => v.connectionStatus === 'OFFLINE'
);



  const [busquedaActivos, setBusquedaActivos] = useState('');
  const [filtroCuenta, setFiltroCuenta] = useState('todos');
  const [valorFiltroCuenta, setValorFiltroCuenta] = useState('');

  const user = JSON.parse(localStorage.getItem('user')) || {};

  const usuarioSeleccionado = usuarios.find(
    (u) => String(u.id) === String(valorFiltroCuenta)
  );

  const vehiclesFiltrados = vehicles.filter((v) => {
    const texto = `
      ${v.name || ''}
      ${v.plate || ''}
      ${v.imei || ''}
      ${v.email || ''}
      ${v.user_email || ''}
      ${v.protocol || ''}
      ${v.company_name || ''}
      ${v.admin_name || ''}
      ${v.user_name || ''}
    `.toLowerCase();

    const coincideBusqueda =
      texto.includes(busquedaActivos.toLowerCase());

    let coincideCuenta = true;

    if (filtroCuenta === 'empresa' && valorFiltroCuenta) {
      coincideCuenta =
        String(v.company_id || '') === String(valorFiltroCuenta);
    }

    if (filtroCuenta === 'admin' && valorFiltroCuenta) {
      coincideCuenta =
        String(v.admin_id || v.parent_user_id || '') ===
        String(valorFiltroCuenta);
    }

    if (filtroCuenta === 'usuario' && valorFiltroCuenta) {
      const selectedEmail =
        usuarioSeleccionado?.email?.toLowerCase() || '';

      const selectedName =
        usuarioSeleccionado?.name?.toLowerCase() || '';

      coincideCuenta =
        String(v.user_id || '') === String(valorFiltroCuenta) ||
        String(v.assigned_user_id || '') === String(valorFiltroCuenta) ||
        String(v.owner_user_id || '') === String(valorFiltroCuenta) ||
        String(v.client_user_id || '') === String(valorFiltroCuenta) ||
        String(v.customer_id || '') === String(valorFiltroCuenta) ||
        String(v.userId || '') === String(valorFiltroCuenta) ||
        String(v.usuario_id || '') === String(valorFiltroCuenta) ||
        String(v.user_email || '').toLowerCase() === selectedEmail ||
        String(v.email || '').toLowerCase() === selectedEmail ||
        String(v.user_name || '').toLowerCase() === selectedName ||
        String(v.client_name || '').toLowerCase() === selectedName;
    }

    return coincideBusqueda && coincideCuenta;
  });

  return (
    <>
{(!isMobile || (
  moduloActivo !== 'historico' &&
  folderTabActiva !== 'geocercas'
)) && (

  <Topbar
  monitorAccounts={monitorAccounts}
  sessionUserId={sessionUserId}
  monitorUserId={selectedMonitorUserId}
  onChangeMonitoring={onChangeMonitoring}
  vehicles={vehicles}
  alertas={alertas}
  geocercas={geocercas}

  onOpenAdministration={() => {
    setFolderTabActiva(null);

    setModoCrearGeocerca(false);
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);

    setModuloActivo(
      'administracion'
    );
  }}

  onOpenConfiguration={() => {
    setFolderTabActiva(null);

    setModoCrearGeocerca(false);
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);

    setModuloActivo(
      'config'
    );
  }}
/>
)}
{isMobile &&
  folderTabActiva !== 'geocercas' &&
  vehicles.length > 0 &&
  (
    moduloActivo === 'mapa' ||
    moduloActivo === 'centinela'
  ) && (
    <VehicleImageCarousel
      vehicles={vehicles}
      selectedVehicle={vehiculoSeleccionado}
      onSelectVehicle={(vehiculo) => {
        setVehiculoSeleccionado(vehiculo);
        setActivoExpandido(false);
      }}
    />
  )}
      {panelActivosAbierto && (
        <div style={isMobile ? styles.panelMobile : styles.panel}>
   <div
  style={
    isMobile
      ? styles.panelHeaderMobile
      : styles.panelHeader
  }
>
  <div>
    {isMobile && (
      <div style={styles.assetsEyebrowMobile}>
        GESTIÓN DE FLOTA
      </div>
    )}

    <h3
      style={
        isMobile
          ? styles.panelTitleMobile
          : styles.panelTitle
      }
    >
      {isMobile
        ? 'Activos'
        : 'Flota activa'}
    </h3>


  </div>

  <button
    onClick={() => {
      setModuloActivo('mapa');
    }}
    style={
      isMobile
        ? styles.assetsCloseButtonMobile
        : styles.closeButton
    }
  >
    ×
  </button>
</div>

          <input
            value={busquedaActivos}
            onChange={(e) => setBusquedaActivos(e.target.value)}
            placeholder="Buscar activo..."
            style={isMobile ? styles.searchInputMobile : styles.searchInput}
          />

          <div style={isMobile ? styles.statsGridMobile : styles.statsGrid}>
            <MiniStat label="Total" value={vehicles.length} color="#38bdf8" isMobile={isMobile} />
            <MiniStat label="Online" value={gpsOnline.length} color="#22c55e" isMobile={isMobile} />
            <MiniStat label="Offline" value={gpsOffline.length} color="#ef4444" isMobile={isMobile} />
          </div>

          <div style={isMobile ? styles.accountFilterMobile : styles.accountFilter}>
            <div style={isMobile ? styles.accountLabelMobile : styles.accountLabel}>
              Cuenta
            </div>

            <div style={isMobile ? styles.accountTabsMobile : styles.accountTabs}>
              <button
                style={{
                  ...(isMobile ? styles.accountTabMobile : styles.accountTab),
                  ...(filtroCuenta === 'todos' ? styles.accountTabActive : {})
                }}
                onClick={() => {
                  setFiltroCuenta('todos');
                  setValorFiltroCuenta('');
                }}
              >
                Todos
              </button>

              {user.role === 'super_admin' && (
                <button
                  style={{
                    ...(isMobile ? styles.accountTabMobile : styles.accountTab),
                    ...(filtroCuenta === 'empresa' ? styles.accountTabActive : {})
                  }}
                  onClick={() => {
                    setFiltroCuenta('empresa');
                    setValorFiltroCuenta('');
                  }}
                >
                  Empresas
                </button>
              )}

              {(user.role === 'super_admin' || user.role === 'admin_empresa') && (
                <button
                  style={{
                    ...(isMobile ? styles.accountTabMobile : styles.accountTab),
                    ...(filtroCuenta === 'admin' ? styles.accountTabActive : {})
                  }}
                  onClick={() => {
                    setFiltroCuenta('admin');
                    setValorFiltroCuenta('');
                  }}
                >
                  Admin
                </button>
              )}

              {(user.role === 'super_admin' ||
                user.role === 'admin_empresa' ||
                user.role === 'administrador') && (
                <button
                  style={{
                    ...(isMobile ? styles.accountTabMobile : styles.accountTab),
                    ...(filtroCuenta === 'usuario' ? styles.accountTabActive : {})
                  }}
                  onClick={() => {
                    setFiltroCuenta('usuario');
                    setValorFiltroCuenta('');
                  }}
                >
                  Usuarios
                </button>
              )}
            </div>

            {filtroCuenta !== 'todos' && (
              <select
                value={valorFiltroCuenta}
                onChange={(e) => setValorFiltroCuenta(e.target.value)}
                style={isMobile ? styles.accountSelectMobile : styles.accountSelect}
              >
                <option value="">
                  {filtroCuenta === 'empresa'
                    ? 'Todas las empresas'
                    : filtroCuenta === 'admin'
                    ? 'Todos los administradores'
                    : 'Todos los usuarios'}
                </option>

                {getOpcionesFiltro(vehicles, usuarios, filtroCuenta).map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            )}
          </div>

     <div
  style={
    isMobile
      ? {
          ...styles.compactListMobile,

          ...(activoExpandido
            ? styles.compactListWithDetailMobile
            : {})
        }
      : styles.compactList
  }
>
            {vehiclesFiltrados.map((vehiculo) => {
            const vehicleKey = getVehicleKey(vehiculo);

const selected =
  getVehicleKey(vehiculoSeleccionado) === vehicleKey;

const status = vehiculo.connectionStatus || 'OFFLINE';

              const ignitionOff =
  vehiculo.ignition === false ||
  vehiculo.ignition === 0 ||
  vehiculo.ignition === '0' ||
  vehiculo.ignition === 'false' ||
  vehiculo.ignition === 'OFF' ||
  vehiculo.ignition === 'APAGADO';

const rawSecondsAgo = vehiculo.secondsAgo;

const secondsAgo =
  rawSecondsAgo === null ||
  rawSecondsAgo === undefined ||
  rawSecondsAgo === ''
    ? null
    : Number(rawSecondsAgo);

const hasValidSecondsAgo =
  Number.isFinite(secondsAgo) && secondsAgo >= 0;

              return (
                <div
                  key={vehicleKey}
                  onClick={() => {
  setVehiculoSeleccionado(vehiculo);

  if (isMobile) {
    setActivoExpandido(true);
  }
}}
                  style={{
                    ...(isMobile ? styles.compactAssetMobile : styles.compactAsset),
                 ...(selected
  ? (
      isMobile
        ? styles.compactAssetSelectedMobile
        : styles.compactAssetSelected
    )
  : {})
                  }}
                >
                  <span
                    style={{
                      ...(isMobile ? styles.statusDotMobile : styles.statusDot),
background:
  status === 'ONLINE'
    ? '#22c55e'
    : status === 'STALE'
    ? '#f59e0b'
    : status === 'SIN_REPORTE'
    ? '#64748b'
    : status === 'OFFLINE' &&
      ignitionOff &&
      hasValidSecondsAgo &&
   secondsAgo <= 2 * 60 * 60
    ? '#3b82f6'
    : status === 'OFFLINE' && ignitionOff
    ? '#94a3b8'
    : '#ef4444'
                    }}
                  />

                  {isMobile ? (
                    <>
                      <div style={styles.assetInfoBlockMobile}>
                        <div style={styles.compactNameMobile}>
                          {vehiculo.name || 'Sin nombre'}
                        </div>

                        <div style={styles.compactMetaMobile}>
                          {vehiculo.plate || 'Sin placa'} · {vehiculo.protocol || 'N/D'}
                        </div>
                      </div>

                      <div style={styles.assetRightBlockMobile}>
                        <span style={styles.speedTextMobile}>
                          {vehiculo.speed || 0} km/h
                        </span>

                        <span style={styles.compactTimeMobile}>
                          {formatLastSeen(vehiculo.secondsAgo)}
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={styles.assetInfoBlock}>
                        <div style={styles.compactName}>
                          {vehiculo.name || 'Sin nombre'}
                        </div>

                        <div style={styles.compactMeta}>
                          {vehiculo.plate || 'Sin placa'} · {vehiculo.protocol || 'N/D'}
                        </div>
                      </div>

                      <div style={styles.assetStatusBlock}>
                        <span style={styles.speedText}>
                          {vehiculo.speed || 0} km/h
                        </span>
                      </div>

                      <div style={styles.compactTime}>
                        {formatLastSeen(vehiculo.secondsAgo)}
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {moduloActivo === 'informes' && (
        <ReportsPanel
          vehiculoSeleccionado={vehiculoSeleccionado}
          monitorUserId={monitorUserId}
          onClose={() => { setFolderTabActiva(null); setModuloActivo('mapa'); }}
        />
      )}

      {isMobile && moduloActivo === 'eventos' && (
        <section style={styles.panelMobile} aria-label="Eventos del vehículo">
          <header style={styles.panelHeaderMobile}>
            <div>
              <div style={styles.assetsEyebrowMobile}>ACTIVIDAD DEL VEHÍCULO</div>
              <h1 style={styles.panelTitleMobile}>Eventos</h1>
            </div>
            <button
              type="button"
              onClick={() => setModuloActivo('mapa')}
              style={styles.assetsCloseButtonMobile}
              aria-label="Cerrar eventos y volver al mapa"
            >×</button>
          </header>
          <div style={styles.eventsVehicleMobile}>
            {vehiculoSeleccionado?.name || 'Selecciona un activo'}
          </div>
          <div style={styles.eventsListMobile}>
            <EventsPanel
              vehiculoSeleccionado={vehiculoSeleccionado}
              monitorUserId={monitorUserId}
              isMobile
            />
          </div>
        </section>
      )}

   {panelFolderActivo && panelFolderActivo !== 'historico' && (
  <div
    style={
      isMobile && panelFolderActivo === 'geocercas'
        ? {
            ...styles.folderPanel,
            position: 'fixed',
            top: 'auto',
            left: '10px',
            right: '10px',
            bottom:
              'calc(env(safe-area-inset-bottom, 0px) + 40px)',
            width: 'auto',
            height: 'auto',
          maxHeight: modoCrearGeocerca
  ? 'min(240px, 36dvh)'
  : 'min(430px, 54dvh)',
            overflowX: 'hidden',
            overflowY: 'auto',
            boxSizing: 'border-box',
            padding: '12px',
            borderRadius: '22px',
          zIndex: 9999,
WebkitOverflowScrolling: 'touch',
background:
  'linear-gradient(155deg, rgba(248,251,255,0.98), rgba(231,241,253,0.97))',
border: '1px solid rgba(255,255,255,0.94)',
boxShadow: '0 14px 36px rgba(15,23,42,0.14)',
color: '#0f172a'
          }
        : isMobile
          ? {
              ...styles.folderPanel,
              position: 'fixed',
              top: 'auto',
              left: '48px',
              right: '0px',
              bottom: '58px',
              width: 'auto',
              height: '20vh',
              maxHeight: '20vh',
              overflowY: 'auto',
              padding: '8px 10px',
              borderRadius: '16px 16px 0 0',
              zIndex: 9300
            }
          : styles.folderPanel
    }
  >
        <div style={isMobile ? styles.folderHeaderMobile : styles.panelHeader}>
  <div>
    <h3
      style={
        isMobile && panelFolderActivo === 'geocercas'
          ? {
              ...styles.folderTitleMobile,
              color: '#063b78',
              fontSize: '22px',
              textTransform: 'none'
            }
          : isMobile
            ? styles.folderTitleMobile
            : styles.panelTitle
      }
    >
      {panelFolderActivo === 'eventos'
        ? 'Eventos'
        : vehiculoSeleccionado
          ? `${panelFolderActivo} · ${vehiculoSeleccionado.name}`
          : panelFolderActivo}
    </h3>

    {vehiculoSeleccionado && (
      <span
        style={
          isMobile && panelFolderActivo === 'geocercas'
            ? { ...styles.panelSubtitle, color: '#475569' }
            : styles.panelSubtitle
        }
      >
        {panelFolderActivo === 'eventos'
          ? vehiculoSeleccionado.name || 'Activo seleccionado'
          : 'Información del activo seleccionado'}
      </span>
    )}
  </div>

  <button
    type="button"
    onClick={() => {
      if (panelFolderActivo === 'geocercas') {
        setModoCrearGeocerca(false);
        setGeocercaTemporal(null);
        setGeocercaSeleccionada(null);
      }

      setFolderTabActiva(null);
    }}
    style={
      isMobile && panelFolderActivo === 'geocercas'
        ? styles.assetsCloseButtonMobile
        : isMobile
          ? styles.closeButtonMobile
          : styles.closeButton
    }
    aria-label="Cerrar panel"
  >
    ×
  </button>
</div>
          {panelFolderActivo === 'eventos' && (
            <EventsPanel vehiculoSeleccionado={vehiculoSeleccionado} monitorUserId={monitorUserId} isMobile={isMobile} />
          )}

    

       {panelFolderActivo === 'geocercas' && (
  <>
    <div
      style={{
        display: 'flex',
        gap: '6px',
        marginBottom: '12px'
      }}
    >
      {[
        ['geocercas', 'Geocercas'],
        ['lugares', 'Mis lugares']
      ].map(([valor, etiqueta]) => (
        <button
          key={valor}
          type="button"
          onClick={() => {
            setModoCrearGeocerca(false);
            setGeocercaTemporal(null);
            setGeocercaSeleccionada(null);
            setVistaGeocercas(valor);
          }}
         style={{
  flex: 1,
  minHeight: isMobile ? '40px' : '34px',
  borderRadius: '10px',
  border: isMobile
    ? vistaGeocercas === valor
      ? '1px solid #2563eb'
      : '1px solid rgba(148,163,184,0.25)'
    : vistaGeocercas === valor
      ? '1px solid #60a5fa'
      : '1px solid rgba(255,255,255,0.18)',
  background: isMobile
    ? vistaGeocercas === valor
      ? '#2563eb'
      : 'rgba(255,255,255,0.88)'
    : vistaGeocercas === valor
      ? 'rgba(37,99,235,0.38)'
      : 'rgba(15,23,42,0.55)',
  color: isMobile && vistaGeocercas !== valor
    ? '#0f172a'
    : '#ffffff',
  fontSize: '11px',
  fontWeight: 800,
  cursor: 'pointer'
}}
        >
          {etiqueta}
        </button>
      ))}
    </div>

   {vistaGeocercas === 'geocercas' ? (
  <GeocercasPanel
    geocercas={geocercas}
    setGeocercas={setGeocercas}
    modoCrearGeocerca={modoCrearGeocerca}
    setModoCrearGeocerca={setModoCrearGeocerca}
    geocercaTemporal={geocercaTemporal}
    setGeocercaTemporal={setGeocercaTemporal}
    geocercaSeleccionada={geocercaSeleccionada}
    setGeocercaSeleccionada={setGeocercaSeleccionada}
    vehiculoSeleccionado={vehiculoSeleccionado}
    monitorUserId={monitorUserId}
  />
) : (
  <div
    style={
      isMobile
        ? {
            padding: '12px',
            borderRadius: '16px',
            background: '#173b69'
          }
        : undefined
    }
  >
    <MisLugaresPanel
      monitorUserId={monitorUserId}
      vehiculoSeleccionado={vehiculoSeleccionado}
      modoCrearGeocerca={modoCrearGeocerca}
      setModoCrearGeocerca={setModoCrearGeocerca}
      geocercaTemporal={geocercaTemporal}
      setGeocercaTemporal={setGeocercaTemporal}
      setGeocercaSeleccionada={setGeocercaSeleccionada}
    />
  </div>
)}
</>
)}

          {panelFolderActivo === 'informes' && (
            <EmptyText text="Informes del activo seleccionado próximamente." />
          )}

          {panelFolderActivo === 'rastreo' && (
            <EmptyText text="Rastreo del activo seleccionado próximamente." />
          )}

          {panelFolderActivo === 'seguridad' && (
            <EmptyText text="Seguridad del activo seleccionado próximamente." />
          )}
        </div>
      )}
    </>
  );
}

function MiniStat({ label, value, color, isMobile }) {
  return (
    <div style={isMobile ? styles.miniStatMobile : styles.miniStat}>
      <span>{label}</span>
      <strong style={{ color }}>{value}</strong>
    </div>
  );
}

function EmptyText({ text }) {
  return <p style={styles.emptyText}>{text}</p>;
}
function VehicleData({ label, value }) {
  return (
    <div style={styles.vehicleExpandedItem}>
      <span style={styles.vehicleExpandedLabel}>
        {label}
      </span>

      <strong style={styles.vehicleExpandedValue}>
        {value}
      </strong>
    </div>
  );
}

function formatBoolean(value, trueText, falseText) {
  if (
    value === true ||
    value === 1 ||
    value === '1' ||
    value === 'true' ||
    value === 'ON' ||
    value === 'ENCENDIDO' ||
    value === 'EN MOVIMIENTO'
  ) {
    return trueText;
  }

  return falseText;
}

function formatInputValue(value) {
  if (
    value === true ||
    value === 1 ||
    value === '1' ||
    value === 'true' ||
    value === 'ON'
  ) {
    return 'ON';
  }

  return 'OFF';
}

function formatVoltage(value) {
  const voltage = Number(value);

  if (Number.isNaN(voltage) || voltage <= 0) {
    return 'Sin datos';
  }

  return `${voltage.toFixed(1)} V`;
}

function formatBatteryPercent(value) {
  const voltage = Number(value);

  if (Number.isNaN(voltage) || voltage <= 0) {
    return 'Sin datos';
  }

  const min = 3.3;
  const max = 4.2;

  const percent = Math.max(
    0,
    Math.min(
      100,
      Math.round(((voltage - min) / (max - min)) * 100)
    )
  );

  return `${percent}%`;
}

function formatGsm(value) {
  const gsm = Number(value);

  if (Number.isNaN(gsm)) return 'Sin datos';
  if (gsm >= 5) return 'Óptima';
  if (gsm >= 4) return 'Buena';
  if (gsm >= 3) return 'Media';
  if (gsm >= 1) return 'Baja';

  return 'Sin señal';
}

function formatGpsSignal(value) {
  const sat = Number(value);

  if (Number.isNaN(sat)) return 'Sin datos';
  if (sat >= 8) return 'Óptima';
  if (sat >= 5) return 'Buena';
  if (sat >= 3) return 'Media';
  if (sat >= 1) return 'Baja';

  return 'Sin señal';
}

function formatKilometraje(value) {
  const odometer = Number(value);

  if (Number.isNaN(odometer)) return 'Sin datos';

 const km = odometer / 1000;

  return `${km.toFixed(1)} km`;
}
function getOpcionesFiltro(vehicles, usuarios, filtroCuenta) {
  const map = new Map();

  if (filtroCuenta === 'empresa') {
    usuarios
      .filter((u) => u.role === 'admin_empresa')
      .forEach((u) => {
        const companyId = u.company_id;

        if (companyId) {
          map.set(companyId, {
            id: companyId,
            name:
              u.company_name ||
              u.company ||
              u.name ||
              `Empresa ${companyId}`
          });
        }
      });
  }

  if (filtroCuenta === 'admin') {
    usuarios
      .filter((u) => u.role === 'administrador')
      .forEach((u) => {
        map.set(u.id, {
          id: u.id,
          name: u.name || u.email || `Administrador ${u.id}`
        });
      });
  }

  if (filtroCuenta === 'usuario') {
    usuarios
      .filter((u) => u.role === 'usuario')
      .forEach((u) => {
        map.set(u.id, {
          id: u.id,
          name: u.name || u.email || `Usuario ${u.id}`
        });
      });
  }

  return Array.from(map.values()).sort((a, b) =>
    a.name.localeCompare(b.name)
  );
}

function formatLastSeen(seconds) {
  if (seconds == null) return '—';
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;

  const days = Math.floor(hours / 24);
  return `${days} d`;
}

const styles = {
  /* =======================================================
     ESCRITORIO
     ======================================================= */

  panel: {
    position: 'absolute',
    top: '138px',
    left: '0px',

    width: '280px',
    height: 'calc(100vh - 154px)',

    overflowY: 'auto',

    zIndex: 3200,

    padding: '18px',

    borderRadius: '0 0 26px 26px',

    background:
      'linear-gradient(180deg, rgba(18,63,115,0.96) 0%, rgba(31,95,159,0.88) 52%, rgba(15,53,95,0.96) 100%)',

    backdropFilter: 'blur(18px)',

    border:
      '1px solid rgba(96,165,250,0.32)',

    boxShadow:
      '0 20px 55px rgba(30,64,175,0.28)',

    color: '#e2e8f0'
  },

  folderPanel: {
    position: 'absolute',
    top: '103px',
    right: '18px',

    width: '340px',
    maxHeight: 'calc(100vh - 125px)',

    overflowY: 'auto',

    zIndex: 3300,

    padding: '18px',

    borderRadius: '0 0 24px 24px',

    background:
      'linear-gradient(180deg, rgba(18,63,115,0.97) 0%, rgba(31,95,159,0.92) 52%, rgba(15,53,95,0.97) 100%)',

    backdropFilter: 'blur(18px)',

    border:
      '1px solid rgba(96,165,250,0.32)',

    borderTop: 'none',

    boxShadow:
      '0 24px 60px rgba(30,64,175,0.32)',

    color: '#e2e8f0'
  },

  folderPanelMobile: {
    position: 'fixed',

    left: '48px',
    right: '0px',
    bottom: '58px',

    height: '20vh',
    maxHeight: '20vh',

    overflowY: 'auto',

    zIndex: 9300,

    padding: '10px 12px',

    borderRadius: '18px 18px 0 0',

    background:
      'linear-gradient(180deg, rgba(18,63,115,0.98) 0%, rgba(31,95,159,0.94) 52%, rgba(15,53,95,0.98) 100%)',

    backdropFilter: 'blur(18px)',

    border:
      '1px solid rgba(96,165,250,0.32)',

    borderBottom: 'none',

    boxShadow:
      '0 -14px 34px rgba(2,8,23,0.38)',

    color: '#e2e8f0'
  },

  panelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',

    marginBottom: '16px'
  },

  panelTitle: {
    margin: 0,

    color: '#ffffff',

    fontSize: '16px',
    fontWeight: '900',

    letterSpacing: '0.6px',
    textTransform: 'uppercase'
  },

  panelSubtitle: {
    display: 'block',

    marginTop: '4px',

    color: '#bae6fd',

    fontSize: '11px',
    fontWeight: '700'
  },

  closeButton: {
    width: '30px',
    height: '30px',

    borderRadius: '10px',

    border:
      '1px solid rgba(255,255,255,0.18)',

    background:
      'rgba(255,255,255,0.08)',

    color: '#ffffff',

    cursor: 'pointer',

    fontWeight: '900'
  },

  searchInput: {
    width: '100%',
    height: '40px',

    marginBottom: '12px',
    padding: '0 12px',

    borderRadius: '14px',

    border:
      '1px solid rgba(148,163,184,0.18)',

    background:
      'rgba(15,23,42,0.72)',

    color: '#ffffff',

    outline: 'none',

    fontSize: '13px',

    boxSizing: 'border-box'
  },

  statsGrid: {
    display: 'grid',

    gridTemplateColumns:
      'repeat(3, 1fr)',

    gap: '8px',
    marginBottom: '14px'
  },

  miniStat: {
    padding: '10px',

    borderRadius: '14px',

    background:
      'rgba(15,23,42,0.72)',

    border:
      '1px solid rgba(148,163,184,0.16)',

    display: 'flex',
    flexDirection: 'column',

    gap: '4px',

    fontSize: '11px',

    color: '#94a3b8'
  },

  accountFilter: {
    marginBottom: '10px',
    padding: '8px',

    borderRadius: '14px',

    background:
      'rgba(3,18,40,0.42)',

    border:
      '1px solid rgba(96,165,250,0.14)'
  },

  accountLabel: {
    marginBottom: '6px',

    color: '#93c5fd',

    fontSize: '10px',
    fontWeight: '900',

    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },

  accountTabs: {
    display: 'flex',
    gap: '5px',
    flexWrap: 'wrap'
  },

  accountTab: {
    padding: '5px 8px',

    borderRadius: '999px',

    border:
      '1px solid rgba(125,211,252,0.16)',

    background:
      'rgba(15,23,42,0.62)',

    color: '#cbd5e1',

    fontSize: '10px',
    fontWeight: '800',

    cursor: 'pointer'
  },

  accountTabActive: {
    background:
      'rgba(14,165,233,0.28)',

    color: '#ffffff',

    border:
      '1px solid rgba(125,211,252,0.45)',

    boxShadow:
      '0 0 12px rgba(14,165,233,0.22)'
  },

  accountSelect: {
    width: '100%',
    height: '30px',

    marginTop: '8px',
    padding: '0 8px',

    borderRadius: '10px',

    border:
      '1px solid rgba(125,211,252,0.18)',

    background:
      'rgba(15,23,42,0.78)',

    color: '#ffffff',

    fontSize: '11px',

    outline: 'none'
  },

  compactList: {
    display: 'flex',
    flexDirection: 'column',

    gap: '5px'
  },

  compactAsset: {
    height: '38px',

    padding: '5px 9px',

    borderRadius: '10px',

    cursor: 'pointer',

    background:
      'rgba(3,18,40,0.78)',

    border:
      '1px solid rgba(96,165,250,0.16)',

    display: 'grid',

    gridTemplateColumns:
      '8px 1fr 55px 38px',

    alignItems: 'center',
    columnGap: '8px',

    transition: 'all 0.16s ease',

    boxSizing: 'border-box'
  },

  compactAssetSelected: {
    background:
      'linear-gradient(135deg, rgba(10,47,96,0.96), rgba(5,25,55,0.96))',

    border:
      '1px solid rgba(14,165,233,0.9)',

    boxShadow:
      '0 0 0 1px rgba(14,165,233,0.25), 0 0 14px rgba(14,165,233,0.32)',

    transform:
      'translateX(2px)'
  },

  statusDot: {
    width: '8px',
    height: '8px',

    borderRadius: '50%'
  },

  assetInfoBlock: {
    minWidth: 0
  },

  compactName: {
    color: '#ffffff',

    fontSize: '12px',
    lineHeight: '13px',
    fontWeight: '900',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  compactMeta: {
    marginTop: '1px',

    color: '#a9bdd6',

    fontSize: '9px',
    lineHeight: '11px',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  assetStatusBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },

  speedText: {
    color: '#c7d2fe',

    fontSize: '9px',
    fontWeight: '800',

    whiteSpace: 'nowrap'
  },

  compactTime: {
    color: '#7dd3fc',

    fontSize: '9px',
    fontWeight: '900',

    textAlign: 'right',
    whiteSpace: 'nowrap'
  },

  emptyText: {
    margin: '10px 0 0',

    color: '#cbd5e1',

    fontSize: '13px',
    lineHeight: '1.5'
  },

  /* =======================================================
     ACTIVOS MÓVIL — COMPACTO
     ======================================================= */

  panelMobile: {
    position: 'fixed',
    inset: 0,

    zIndex: 7000,

    width: '100%',
    height: '100%',

    paddingTop:
      'calc(env(safe-area-inset-top, 0px) + 66px)',

    paddingRight: '14px',

    paddingBottom:
      'calc(env(safe-area-inset-bottom, 0px) + 84px)',

    paddingLeft: '14px',

    boxSizing: 'border-box',

    display: 'flex',
    flexDirection: 'column',

    overflow: 'hidden',

    border: 0,
    borderRadius: 0,

    background: `
      linear-gradient(
        155deg,
        #f8fbff 0%,
        #eef5fd 48%,
        #e3effc 100%
      )
    `,

    color: '#0f172a'
  },

  panelHeaderMobile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    flexShrink: 0,

    gap: '10px',
    marginBottom: '8px'
  },

  assetsEyebrowMobile: {
    marginBottom: '2px',

    color: '#2563eb',

    fontSize: '8px',
    lineHeight: '10px',
    fontWeight: '950',

    letterSpacing: '1.5px'
  },

  panelTitleMobile: {
    margin: 0,

    color: '#063b78',

    fontSize: '27px',
    lineHeight: '29px',
    fontWeight: '950',

    letterSpacing: '-0.8px',
    textTransform: 'none'
  },

  eventsVehicleMobile: {
    flexShrink: 0,
    margin: '14px 0 12px',
    padding: '13px 16px',
    borderRadius: '16px',
    border: '1px solid rgba(255,255,255,0.95)',
    background: 'rgba(255,255,255,0.84)',
    boxShadow: '0 6px 18px rgba(15,23,42,0.06)',
    color: '#063b78',
    fontSize: '15px',
    fontWeight: '850'
  },
  eventsListMobile: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    padding: '2px 2px 12px'
  },

  /*
    Si todavía existe la descripción en el JSX,
    la ocultamos para no ocupar espacio.
  */
  assetsDescriptionMobile: {
    display: 'none'
  },

  assetsCloseButtonMobile: {
    width: '34px',
    height: '34px',
    minWidth: '34px',

    margin: 0,
    padding: 0,

    borderRadius: '50%',

    border:
      '1px solid rgba(148,163,184,0.22)',

    background:
      'rgba(255,255,255,0.86)',

    color: '#0f172a',

    boxShadow:
      '0 5px 13px rgba(15,23,42,0.07)',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    fontSize: '21px',
    lineHeight: 1,
    fontWeight: '500',

    cursor: 'pointer',

    WebkitTapHighlightColor:
      'transparent'
  },

  searchInputMobile: {
    width: '100%',
    height: '39px',

    flexShrink: 0,

    marginBottom: '7px',
    padding: '0 12px',

    boxSizing: 'border-box',

    borderRadius: '13px',

    border:
      '1px solid rgba(255,255,255,0.94)',

    background:
      'rgba(255,255,255,0.84)',

    color: '#0f172a',

    boxShadow:
      '0 6px 16px rgba(15,23,42,0.055)',

    outline: 'none',

    fontSize: '12px',
    fontWeight: '700'
  },

  statsGridMobile: {
    display: 'grid',

    gridTemplateColumns:
      'repeat(3, minmax(0, 1fr))',

    flexShrink: 0,

    gap: '6px',
    marginBottom: '7px'
  },

  miniStatMobile: {
    minWidth: 0,
    minHeight: '40px',

    padding: '6px 8px',

    boxSizing: 'border-box',

    borderRadius: '12px',

    background:
      'rgba(255,255,255,0.80)',

    border:
      '1px solid rgba(255,255,255,0.92)',

    boxShadow:
      '0 5px 14px rgba(15,23,42,0.05)',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    gap: '4px',

    color: '#64748b',

    fontSize: '8px',
    fontWeight: '800'
  },

  accountFilterMobile: {
    flexShrink: 0,

    marginBottom: '8px',
    padding: '7px 8px',

    borderRadius: '14px',

    background:
      'rgba(255,255,255,0.68)',

    border:
      '1px solid rgba(255,255,255,0.90)',

    boxShadow:
      '0 5px 14px rgba(15,23,42,0.045)'
  },

  accountLabelMobile: {
    marginBottom: '5px',

    color: '#2563eb',

    fontSize: '8px',
    lineHeight: '9px',
    fontWeight: '950',

    letterSpacing: '1px',
    textTransform: 'uppercase'
  },

  accountTabsMobile: {
    display: 'flex',

    gap: '5px',
    flexWrap: 'wrap'
  },

  accountTabMobile: {
    minHeight: '27px',

    padding: '4px 9px',

    borderRadius: '999px',

    border:
      '1px solid rgba(148,163,184,0.18)',

    background:
      'rgba(241,245,249,0.84)',

    color: '#334155',

    fontSize: '8px',
    fontWeight: '900',

    cursor: 'pointer',

    WebkitTapHighlightColor:
      'transparent'
  },

  accountSelectMobile: {
    width: '100%',
    height: '30px',

    marginTop: '6px',
    padding: '0 8px',

    boxSizing: 'border-box',

    borderRadius: '9px',

    border:
      '1px solid rgba(148,163,184,0.18)',

    background: '#ffffff',

    color: '#0f172a',

    fontSize: '9px',
    fontWeight: '700',

    outline: 'none'
  },

  compactListMobile: {
    minHeight: 0,
    flex: 1,

    display: 'flex',
    flexDirection: 'column',

    gap: '5px',

    padding: '1px 2px 8px',

    overflowX: 'hidden',
    overflowY: 'auto',

    WebkitOverflowScrolling:
      'touch'
  },

  compactListWithDetailMobile: {
    paddingBottom: '222px'
  },

  compactAssetMobile: {
    minHeight: '47px',
    height: '47px',
    flexShrink: 0,

    padding: '6px 9px',

    boxSizing: 'border-box',

    borderRadius: '14px',

    cursor: 'pointer',

    background:
      'rgba(255,255,255,0.84)',

    border:
      '1px solid rgba(255,255,255,0.94)',

    boxShadow:
      '0 5px 14px rgba(15,23,42,0.055)',

    display: 'grid',

    gridTemplateColumns:
      '8px minmax(0, 1fr) 55px',

    alignItems: 'center',
    columnGap: '8px',

    transition:
      'transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease',

    WebkitTapHighlightColor:
      'transparent'
  },

  compactAssetSelectedMobile: {
    transform:
      'translateY(-1px)',

    background:
      'linear-gradient(145deg, rgba(255,255,255,0.96), rgba(224,242,254,0.90))',

    border:
      '1px solid rgba(14,165,233,0.68)',

    boxShadow:
      '0 7px 17px rgba(14,165,233,0.11)'
  },

  statusDotMobile: {
    width: '8px',
    height: '8px',

    borderRadius: '50%',

    boxShadow:
      '0 0 0 2px rgba(148,163,184,0.10)'
  },

  assetInfoBlockMobile: {
    minWidth: 0
  },

  compactNameMobile: {
    color: '#0f172a',

    fontSize: '11px',
    lineHeight: '12px',
    fontWeight: '950',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  compactMetaMobile: {
    marginTop: '2px',

    color: '#64748b',

    fontSize: '8px',
    lineHeight: '9px',
    fontWeight: '700',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  assetRightBlockMobile: {
    minWidth: 0,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',

    gap: '2px'
  },

  speedTextMobile: {
    color: '#0f172a',

    fontSize: '8px',
    lineHeight: '9px',
    fontWeight: '950',

    whiteSpace: 'nowrap'
  },

  compactTimeMobile: {
    display: 'block',

    color: '#2563eb',

    fontSize: '8px',
    lineHeight: '9px',
    fontWeight: '900',

    textAlign: 'right',
    whiteSpace: 'nowrap'
  },

  /* =======================================================
     OTROS PANELES MÓVILES
     ======================================================= */

  closeButtonMobile: {
    width: '26px',
    height: '26px',

    padding: 0,

    borderRadius: '9px',

    border:
      '1px solid rgba(255,255,255,0.18)',

    background:
      'rgba(255,255,255,0.08)',

    color: '#ffffff',

    cursor: 'pointer',

    fontWeight: '900',
    fontSize: '16px'
  },

  folderHeaderMobile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    marginBottom: '8px'
  },

  folderTitleMobile: {
    margin: 0,

    color: '#ffffff',

    fontSize: '13px',
    fontWeight: '900',

    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },

  /* =======================================================
     CARRUSEL
     ======================================================= */

  vehicleCarouselWrapper: {
    position: 'fixed',

    top: '52px',
    left: '0',
    right: '0',

    zIndex: 9100,

    padding: '6px 8px',

    boxSizing: 'border-box',

    pointerEvents: 'none'
  },

  vehicleCarousel: {
    width: '100%',

    display: 'flex',

    gap: '8px',

    overflowX: 'auto',
    overflowY: 'hidden',

    padding: '2px 1px 6px',

    boxSizing: 'border-box',

    scrollSnapType:
      'x mandatory',

    WebkitOverflowScrolling:
      'touch',

    scrollbarWidth: 'none',

    pointerEvents: 'auto'
  },

  vehicleCarouselCard: {
    flex: '0 0 210px',

    height: '88px',

    padding:
      '5px 8px 5px 5px',

    borderRadius: '18px',

    border:
      '1px solid rgba(255,255,255,0.72)',

    background:
      'rgba(255,255,255,0.78)',

    WebkitBackdropFilter:
      'blur(20px) saturate(160%)',

    backdropFilter:
      'blur(20px) saturate(160%)',

    boxShadow:
      '0 8px 24px rgba(15,23,42,0.14)',

    display: 'flex',
    alignItems: 'center',

    gap: '8px',

    scrollSnapAlign: 'center',

    boxSizing: 'border-box',

    cursor: 'pointer',
    outline: 'none',

    WebkitTapHighlightColor:
      'transparent',

    transition:
      'transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease'
  },

  vehicleCarouselCardSelected: {
    transform:
      'translateY(-1px)',

    border:
      '1px solid rgba(255,255,255,0.82)',

    boxShadow:
      '0 14px 38px rgba(15,23,42,0.16), 0 2px 8px rgba(15,23,42,0.06)'
  },

  vehiclePhotoPlaceholder: {
    position: 'relative',

    width: '68px',
    height: '68px',
    minWidth: '68px',

    borderRadius: '20px',

    background:
      'linear-gradient(145deg, rgba(241,245,249,0.98), rgba(226,232,240,0.88))',

    border:
      '1px solid rgba(255,255,255,0.90)',

    boxShadow:
      'inset 0 1px 0 rgba(255,255,255,0.95), 0 8px 20px rgba(15,23,42,0.08)',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    overflow: 'visible'
  },

  vehicleInitial: {
    color: '#111827',

    fontSize: '28px',
    fontWeight: '900'
  },

  vehicleStatusDot: {
    position: 'absolute',

    right: '-2px',
    bottom: '-2px',

    width: '10px',
    height: '10px',

    borderRadius: '50%',

    border:
      '2px solid #ffffff',

    boxSizing: 'border-box'
  },

  vehicleCarouselInfo: {
    minWidth: 0,
    flex: 1,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },

  vehicleCarouselName: {
    width: '100%',

    color: '#111827',

    fontSize: '14px',
    lineHeight: '13px',
    fontWeight: '900',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    textAlign: 'left'
  },

  vehicleCarouselMeta: {
    width: '100%',

    marginTop: '2px',

    color: '#475569',

    fontSize: '10px',
    lineHeight: '10px',
    fontWeight: '700',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    textAlign: 'left'
  },

  vehicleCarouselSpeed: {
    marginTop: '2px',

    color: '#0f172a',

    fontSize: '10px',
    lineHeight: '10px',
    fontWeight: '900'
  },

  vehicleCarouselTopRow: {
    width: '100%',
    minWidth: 0,

    display: 'flex',
    alignItems: 'center',

    gap: '8px'
  },

  vehicleCarouselCardExpanded: {
    flex:
      '0 0 calc(100vw - 24px)',

    height: '250px',

    alignItems: 'flex-start',
    flexDirection: 'column',

    gap: '10px',

    padding: '10px',

    transform:
      'translateY(0)',

    overflow: 'hidden',

    borderRadius: '24px',

    background:
      'rgba(255,255,255,0.88)',

    WebkitBackdropFilter:
      'blur(28px) saturate(150%)',

    backdropFilter:
      'blur(28px) saturate(150%)'
  },

  vehicleMinimizeButton: {
    width: '32px',
    height: '32px',
    minWidth: '32px',

    padding: 0,

    borderRadius: '50%',

    border:
      '1px solid rgba(15,23,42,0.08)',

    background:
      'rgba(248,250,252,0.88)',

    color: '#111827',

    fontSize: '20px',
    lineHeight: '20px',
    fontWeight: '700',

    cursor: 'pointer',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    boxShadow:
      '0 5px 14px rgba(15,23,42,0.08)',

    WebkitTapHighlightColor:
      'transparent'
  },

  vehicleExpandedGrid: {
    width: '100%',
    flex: 1,

    display: 'grid',

    gridTemplateColumns:
      'repeat(4, minmax(0, 1fr))',

    gap: '6px',

    overflowY: 'auto',

    alignContent: 'start',

    padding: '2px 2px 4px',

    boxSizing: 'border-box',

    WebkitOverflowScrolling:
      'touch'
  },

  vehicleExpandedItem: {
    minWidth: 0,
    height: '42px',

    padding: '5px 4px',

    borderRadius: '13px',

    background:
      'rgba(248,250,252,0.58)',

    border:
      '1px solid rgba(226,232,240,0.56)',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    boxSizing: 'border-box'
  },

  vehicleExpandedLabel: {
    width: '100%',

    color: '#64748b',

    fontSize: '7px',
    lineHeight: '8px',
    fontWeight: '700',

    textAlign: 'center',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  vehicleExpandedValue: {
    width: '100%',

    marginTop: '3px',

    color: '#111827',

    fontSize: '9px',
    lineHeight: '10px',
    fontWeight: '900',

    textAlign: 'center',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  vehicleStateChip: {
    width: 'fit-content',
    maxWidth: '100%',

    marginTop: '7px',
    padding: '4px 8px',

    borderRadius: '999px',

    display: 'inline-flex',
    alignItems: 'center',

    gap: '5px',

    fontSize: '8px',
    lineHeight: '9px',
    fontWeight: '800',

    whiteSpace: 'nowrap'
  },

  vehicleStateChipDot: {
    width: '6px',
    height: '6px',

    borderRadius: '50%',

    flexShrink: 0
  },

  vehicleHeaderActions: {
    marginLeft: 'auto',

    display: 'flex',
    alignItems: 'center',

    gap: '8px',

    flexShrink: 0
  },

  vehicleSpeedSummary: {
    minWidth: '56px',
    height: '54px',

    padding: '3px 7px',

    borderRadius: '16px',

    background:
      'rgba(248,250,252,0.62)',

    border:
      '1px solid rgba(226,232,240,0.72)',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    boxSizing: 'border-box'
  },

  vehicleSpeedNumber: {
    color: '#0f172a',

    fontSize: '22px',
    lineHeight: '22px',
    fontWeight: '900',

    letterSpacing: '-0.8px'
  },

  vehicleSpeedUnit: {
    marginTop: '2px',

    color: '#64748b',

    fontSize: '7px',
    lineHeight: '8px',
    fontWeight: '800'
  }
};

export default MonitoringLayout;
